import axios from 'axios';
import { CreatePowerPlantInputs } from '../../../pages/power-plant';
import { getApiInstance } from '../api';

export const updatePowerPlant = async ({
  token,
  powerPlantId,
  userInput,
}: {
  token: string;
  powerPlantId: string;
  userInput: CreatePowerPlantInputs;
}) => {
  const api = getApiInstance(token);
  try {
    await api.put(`/power-plants/${powerPlantId}`, userInput);

    return { success: true };
  } catch (error) {
    console.error(error);

    if (axios.isAxiosError(error) && error.response?.status) {
      if (error.response?.status === 400) {
        const apiMessage = error?.response?.data?.message;
        const arrayOfMessages =
          typeof apiMessage === 'string' ? [apiMessage] : apiMessage || [];
        const message = ['Erro ao atualizar usina.', ...arrayOfMessages].join(
          ' ',
        );
        return {
          success: false,
          message,
        };
      }
      return {
        success: false,
        message: `Erro ao atualizar usina. ${error.response?.data.message}`,
      };
    }

    return {
      success: false,
      message: `Erro ao atualizar usina. Erro desconhecido: ${
        (error as Error).message
      }`,
    };
  }
};
